import React, { useEffect, useState } from 'react';
import classes from "./ConfirmationPage.module.css";
import Header from '../components/Header';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { baseURL, confirmSubAPI, login } from '../http/http';
import { useDispatch } from 'react-redux';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import SmallLoader from '../components/Loaders/SmallLoader';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import {
    FaCircleCheck,
    FaXmark,
    FaMoneyBillWave,
    FaRotate,
    FaBagShopping,
} from 'react-icons/fa6';

const epochSeconds = () => Math.floor(Date.now() / 1000);
const genTi = (prefix = "QM") => `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const ConfirmationPage2 = () => {

    const location = useLocation();
    const [loading, setLoading] = useState(false);

    const [msisdn, setMsisdn] = useState(null);
    const [extRef, setExtRef] = useState(null);
    const [pack, setPack] = useState(null);
    const [autoRenew, setAutoRenew] = useState(null);

    const [isDaily, setIsDaily] = useState(null);

    const [isWeek, setIsWeek] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { t } = useTranslation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setPack(location?.state?.pack);
            setAutoRenew(location?.state?.autoRenew)

            setIsDaily(() => location?.state?.pack == 'Daily');
            setIsWeek(() => location?.state?.pack == 'Weekly');
        }
        else {
            navigate("/");
        }
    }, [location]);


    const [ti, setTi] = useState("");
    const [ts, setTs] = useState(0);
    const [afLoaded, setAfLoaded] = useState(false);

    // Add referrer meta per spec so platform can detect the referrer
    useEffect(() => {
        const meta = document.createElement("meta");
        meta.name = "referrer";
        meta.content = "unsafe-url";
        document.head.appendChild(meta);
        return () => document.head.removeChild(meta);
    }, []); // :contentReference[oaicite:6]{index=6}

    useEffect(() => {

        if (!msisdn) {
            return;
        }

        setAfLoaded(false);

        const _ti = genTi("QM");
        const _ts = epochSeconds();
        setTi(_ti);
        setTs(_ts);

        const params = {
            ti: _ti, // DONE
            ts: _ts, // DONE
            country: 'CM', // DONE
            carrier: '62401', // DONE
            service: 'Quiz Masters',
            user_id: msisdn,
            // pl: ["mtn_cm"], // DONE
            pl: "mtn_cm", // DONE
            te: "#cta_button", // DONE
        };

        // remove any previously added antifraud script
        const existingScript = document.getElementById("antifraud-script");
        if (existingScript) {
            existingScript.parentNode.removeChild(existingScript);
            console.log("Old antifraud script removed");
        }

        // define the evina gateway-load handler once so we can remove it on cleanup
        const onGatewayLoad = () => {
            console.log("Evina gateway-load received");
            setAfLoaded(true);
        };

        axios
            .get(`${baseURL}api/v1/get-script`, {
                params
            })
            .then(({ data }) => {
                let top_head = document.getElementsByTagName("head")[0];
                const s = document.createElement("script");
                s.type = "text/javascript";
                s.defer = false;
                // s.text = data?.data?.script;
                s.innerHTML = data?.data?.script;
                // s.text = "dcbprotect";
                s.id = "antifraud-script";

                top_head.insertBefore(s, top_head.firstChild);

                // const head = document.head || document.getElementsByTagName("head")[0];
                // head.insertBefore(s, head.firstChild);

                console.log("New antifraud script inserted");

                try {
                    const ev = new Event("DCBProtectRun");
                    document.dispatchEvent(ev);
                    document.addEventListener("gateway-load", onGatewayLoad, { once: true });
                } catch (e) {
                    console.warn("Could not dispatch/listen Evina events:", e);
                    setAfLoaded(true);
                }
            })
            .catch((e) => {
                console.error("Antifraud script load failed:", e);
                setAfLoaded(false);
                alert(t("86"));
            });


        // cleanup on unmount or when selectedPlan changes
        return () => {
            document.removeEventListener("gateway-load", onGatewayLoad);
            const script = document.getElementById("antifraud-script");
            if (script) {
                script.parentNode.removeChild(script);
                console.log("Antifraud script removed on unmount");
            }
        };
    }, [msisdn]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            let params = {
                ti,
                ts,
                country: 'CM',
                user_id: msisdn,
                service: 'Quiz Masters',
            }

            const response = await axios.get(`${baseURL}api/v1/check-script`, {
                params
            });

            console.log(response?.data?.data?.data, 'response--');

            if (response?.data?.data?.data?.ft >= 1000 && response?.data?.data?.data?.ft < 1999) {
                // make the api call here please=

                const response2 = await confirmSubAPI(msisdn, pack, extRef, autoRenew, ti, ts);

                setLoading(false);

                navigate("/subscription-processing", {
                    state: {
                        msisdn: msisdn
                    }
                })
            }
            else {
                setLoading(false);
                // make a modal and show that this is an invalid traffic!
                navigate(`/invalid-traffic?ft=${response?.data?.data?.data?.ft}`);
            }


        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("94"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    return (
        <>
            <Header />
            <div className={classes.container}>
                <div className={classes.content}>
                    <h2 className={classes.title}>{t("205")}</h2>
                    <span
                        className={`${classes.planChip} ${isDaily ? classes.dailyChip : classes.weeklyChip
                            }`}
                    >
                        {isDaily ? t("199") : isWeek ? t("200") : t("216")}
                    </span>


                    <p className={classes.description}>
                        {t("206")}{' '}
                        <span className={classes.highlight}>{isDaily ? t("195") : isWeek ? t("196") : t("217")}</span> / {isDaily ? t("201") : isWeek ? t("202") : t("218")} {t("207")}{' '}
                        <span className={classes.highlight}>{autoRenew ? t("203") : t("204")}</span>.
                    </p>

                    <div className={classes.summaryCard}>
                        <div className={classes.infoRow}>
                            <div className={classes.infoLeft}>
                                <FaBagShopping className={classes.rowIcon} />
                                <span className={classes.infoLabel}>{t("208")}</span>
                            </div>
                            <span className={classes.infoValue}>{isDaily ? t("197") : isWeek ? t("198") : t("219")}</span>
                        </div>

                        <div className={classes.infoRow}>
                            <div className={classes.infoLeft}>
                                <FaMoneyBillWave className={classes.rowIcon} />
                                <span className={classes.infoLabel}>{t("209")}</span>
                            </div>
                            <span className={classes.infoValue}>
                                {isDaily ? t("195") : isWeek ? t("196") : t("217")} / {isDaily ? t("201") : isWeek ? t("202") : t("218")}
                            </span>
                        </div>

                        <div className={classes.infoRow}>
                            <div className={classes.infoLeft}>
                                <FaRotate className={classes.rowIcon} />
                                <span className={classes.infoLabel}>{t("210")}</span>
                            </div>
                            <span className={classes.infoValue}>{autoRenew ? t("203") : t("204")}</span>
                        </div>
                    </div>

                    {loading || !afLoaded ?
                        <div style={{ marginTop: "14px" }}>
                            <SmallLoader style={{ border: "5px solid #fff" }} />
                            <p>{t("213")}</p>
                        </div>
                        :
                        <div className={classes.buttonGroup}>
                            <button
                                type="button"
                                className={classes.noButton}
                                onClick={() => navigate("/")}
                            >
                                {t("211")}
                            </button>

                            <button
                                type="button"
                                id='cta_button'
                                disabled={!afLoaded || loading}
                                className={`${classes.yesButton} ${isDaily ? classes.dailyButton : classes.weeklyButton
                                    }`}
                                onClick={handleFormSubmission}
                            >
                                {t("212")}
                            </button>
                        </div>
                    }

                </div>
            </div>
        </>

    )
}

export default ConfirmationPage2